export default "__VITE_ASSET__b350ab38__"